<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined>
        <v-skeleton-loader type="table-heading"></v-skeleton-loader>
      </v-card>
    </v-col>

    <v-col>
      <v-card outlined>
        <v-skeleton-loader type="table-thead, table-tbody"></v-skeleton-loader>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TableSkeletonLoader'
}
</script>
